import { useEffect, useState } from 'react'
import arrowRight from '../../assets/icons/arrow-right.png'
import arrowLeft from '../../assets/icons/arrow-left.png'
import { Header24, SubHeader24 } from '../../styles/typography'
import styled from '@emotion/styled'

const SelectedCircle = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: ${(props) => props.theme.primaryColor.black[1]};
    cursor: pointer;
`

const Circle = styled(SelectedCircle)`
    background-color: ${(props) => props.theme.primaryColor.grey[1]};
`

const ArrowHover = styled.div`
    position: relative;
    cursor: pointer;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: opacity 0.3s ease;
        border-radius: 100%;
    }

    &:hover::after {
        opacity: 1;
    }
`

const TextContainer = styled.div`
    width: 100%;
    display: block;
    flex-shrink: 0;
    flex-grow: 0;

    h1 {
        font-family: Yantramanav-Bold;
        font-size: 24px;
        color: ${(props) => props.theme.primaryColor.blue[1]};
    }

    h2 {
        font-family: Inter-Light;
        font-size: 24px;
        margin-top: unset;
        margin-bottom: 8px;
        font-weight: 200;
        color: #262723;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        h1 {
            font-size: 20px;
        }

        h2 {
            font-size: 16px;
        }
    }
`

type Testimonial = {
    Name: string
    Testimonial: string
}

type TextSliderProps = {
    textContent: Testimonial[]
}

export function TextSlider({ textContent }: TextSliderProps) {
    const [textIndex, setTextIndex] = useState(0)

    function showNextImage() {
        setTextIndex((index) => {
            if (index === textContent.length - 1) return 0
            return index + 1
        })
    }

    function showPrevImage() {
        setTextIndex((index) => {
            if (index === 0) return textContent.length - 1
            return index - 1
        })
    }

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         showNextImage()
    //     }, 3000)

    //     return () => clearInterval(interval)
    // }, [textContent.length])

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                    <div
                        style={{
                            display: 'flex',
                            transition: 'translate 0.6s ease-in-out',
                            translate: `${-100 * textIndex}%`,
                        }}
                    >
                        {textContent.map((text, index) => (
                            <TextContainer key={index}>
                                <h2>&quot;{text.Testimonial}&quot;</h2>
                                <h1>{text.Name}</h1>
                            </TextContainer>
                        ))}
                    </div>
                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '4px' }}>
                        {textContent.map((_, index) => (
                            <div key={index} onClick={() => setTextIndex(index)}>
                                {index === textIndex ? <SelectedCircle /> : <Circle />}
                            </div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <ArrowHover onClick={showPrevImage}>
                            <img style={{ width: '40px', height: '40px', cursor: 'pointer' }} src={arrowLeft} />
                        </ArrowHover>

                        <ArrowHover onClick={showNextImage}>
                            <img style={{ width: '40px', height: '40px', cursor: 'pointer' }} src={arrowRight} />
                        </ArrowHover>
                    </div>
                </div>
            </div>
        </>
    )
}
